<template>
  <div id="app">
    {{ stateSync }}
    <LoginModal />
    <router-view />
    <GlobalToast />
    <div v-if="showGlobalSpinner" class="global-route-loader">
      <Spinner />
    </div>
  </div>
</template>
<script>
import {
  startTokenExpiryWatcher,
} from "./utils/tokenCheck";
import { refreshAccessToken } from "./utils/request";
import GlobalToast from "./components/fixedComponents/Toast.vue";
import LoginModal from "./components/common/LoginModal.vue";
import {
  canRegister,
  getCandidateOnboard,
  checkCandidateSignin,
} from "./utils/apiFunctions";
import {
  getAccess,
  getToken,
  ensureGuestUUID,
  hasAccess,
} from "./utils/tokenCheck";
import { getProcessedToken } from "./utils/request";
import { appConfig } from "./config/appConfig";
import Spinner from "./components/fixedComponents/Spinner.vue";
export default {
  name: "App",
  data() {
    return {
      isBooting: true,
      excludedOnboardingPages: ["PublicCertificate"],
    };
  },
  components: {
    GlobalToast,
    LoginModal,
    Spinner,
  },
  computed: {
    showGlobalSpinner() {
      return this.isBooting;
    },
    stateSync() {
      var stt = this.$store.state;
      localStorage.setItem("simpTrainingCandidate", JSON.stringify(stt));
      return "";
    },
    hasAccess() {
      return hasAccess();
    },
  },
  async created() {
    var savedstate = localStorage.getItem("simpTrainingCandidate");
    if (savedstate != null) {
      this.$store.replaceState(JSON.parse(savedstate));
    }
    let val = getAccess("candidate") && getToken() ? true : false;
    this.$store.commit("userVUEX/setCandAccess", val);
    try {
      if (!this.hasAccess) {
        ensureGuestUUID();
      } else {
        refreshAccessToken();
        startTokenExpiryWatcher();
        const promises = [];
        if (!this.excludedOnboardingPages.includes(this.$route.name)) {
          promises.push(this.getInitialUserData());
        }
        promises.push(this.getuserInfo());
        await Promise.all(promises);
      }
    } catch (error) {
      console.error("Error booting application:", error);
    } finally {
      this.$router.onReady(() => {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.isBooting = false;
            });
          });
        });
      });
    }
  },
  methods: {
    async getInitialUserData() {
      try {
        const onboardRes = await getCandidateOnboard();
        const onboardData = onboardRes?.data?.data;
        console.log(
          "[Onboarding][loginMixin] getCandidateOnboard response:",
          onboardData,
        );
        if(onboardRes.status === 404 || onboardRes.status == 200 && onboardData?.onboardingCompleted == false){
            const returnUrl = encodeURIComponent(window.location.href);
              window.location.href = `${appConfig.candidateBase}/homepage?from=candidate&fromTraining=1&returnUrl=${returnUrl}`;
        }
        
      } catch (error) {
        // getCandidateOnboard failed — fall back to checkCandidateSignin
        console.error(
          "Onboarding check failed, falling back to checkCandidateSignin:",
          error,
        );
        try {
          const userID = getProcessedToken();
          if (userID) {
            const checkRes = await checkCandidateSignin({
              check_completion: "true",
              userID,
            });
            const isCandidate = checkRes?.data?.data?.isCandidate;
            if (isCandidate === false || isCandidate === "false") {
              const returnUrl = encodeURIComponent(window.location.href);
              console.log(
                "[App] isCandidate=false, redirecting to candidate URL",
              );
              window.location.href = `${appConfig.candidateBase}/homepage?from=candidate&fromTraining=1&returnUrl=${returnUrl}`;
            }
          }
        } catch (signinError) {
          console.error(
            "checkCandidateSignin failed, proceeding normally:",
            signinError,
          );
        }
      }
    },
    async getuserInfo() {
      try {
        const res = await canRegister();
        if (res.status == 200) {
          this.$store.commit("userVUEX/setUserInfo", res.data.data);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    },
  },
};
</script>

<style>
@import "@/assets/globalcss/newstyle.css";
@import "@/assets/globalcss/typography.css";

.global-route-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.global-route-loader .loader {
  margin-left: 0 !important;
}
</style>
